import React, { useEffect } from "react";
import Navbar from "../components/partial/Navbar";
import banner from "../asset/blogs-banner.png";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link, useParams } from "react-router-dom";
import Footer from "../components/partial/Footer";
import { useGetBlogDetailsQuery } from "../../redux/API/BlogApi";
import { blogImgUrl, ImgUrl } from "../../constant";
import BlogCard from "../components/card/BlogCard";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
const BlogDetail = () => {

  const { slug } = useParams();
  const { data: blogData } = useGetBlogDetailsQuery(slug);

  useEffect(() => {
    AOS.init({
      delay: 100,
      duration: 600,
      easing: "ease",
      once: false,
      mirror: false,
    });
  }, []);


  return (
    <>
      <Navbar />
      <div className="hero_banner">
        <img src={`${ImgUrl}${blogImgUrl}${blogData?.data?.blog?.image}`} alt={blogData?.title} className="w-100 h-100" />

      </div>

      <section className="mt-3 container">
        <div className="row">
          <div className="col-lg-12">
            <h2>{blogData?.data?.blog?.title}</h2>
            <div className="blog-description">
              <p dangerouslySetInnerHTML={{ __html: blogData?.data?.blog?.description }} />
            </div>

          </div>
          <div className="col-lg-12">
            <h3>Recent Blogs</h3>
            <Swiper
                slidesPerView={1}
                spaceBetween={10}
                className="mySwiper"
                breakpoints={{
                  640: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                  },
                  768: {
                    slidesPerView: 3,
                    spaceBetween: 10,
                  },
                  1024: {
                    slidesPerView: 4,
                    spaceBetween: 10,
                  },
                }}
                >
            {
              blogData?.data?.remainingBlogs?.map((blog) => (

                
                  <SwiperSlide>
                  <div className="col-12">
                    <Link
                      to={`/blogs/${blog.slug}`}
                      className="text-decoration-none text-unset"
                    >
                      
                      <BlogCard
                        title={blog.title}
                        desc={
                          blog.description
                            ? blog.description
                              .replace(/(<([^>]+)>)/gi, "")
                              .slice(0, 45) + "..."
                            : "Read more about this amazing journey"
                        }
                        img={`${ImgUrl}${blogImgUrl}${blog.image}`}
                        slug={blog?.slug}
                        border={"#005028"}
                      />
                    </Link>
                        </div>
                  </SwiperSlide>
               


              ))
            }
             </Swiper>

          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default BlogDetail;
